import React from "react";
import "./index.css";
import { appHost } from "../../helpers/uri";

const PrintHeader = () => {
  return (
    <div className="print-header">
      <div className="logo-container">
        <img 
          src={`${appHost}images/logo.png`} 
          className="institution-logo" 
          alt="College Logo" 
        />
      </div>
      
      <div className="institution-info">
        <h1 className="institution-name">
          Kebbi State Polytechnic Dakingari
        </h1>
        
        <p className="campus-location">
          Nasarawa Annex Campus, Dakingari, Kebbi STATE
        </p>
      </div>
    
    </div>
  );
};

export default PrintHeader;
